// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hxZW","footer":"styles_footer__ahAFi","passCodeTooltip":"styles_passCodeTooltip__3HQBF"};